import { Component, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Insurance, Patient } from 'src/app/core/models';
import { PatientState } from 'src/app/core/store/patient/patient.state';

@Component({
  selector: 'app-insurance-details',
  templateUrl: './insurance-details.component.html',
  styleUrls: ['./insurance-details.component.scss'],
})
export class InsuranceDetailsComponent {
  @Input() insurance!: Insurance;
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;

  insuranceMask = new RegExp(/.(?=.{4})/, 'g');

  constructor() {}
}
